

const angular = require('angular');

export default angular.module('safestartServerApp.statCard', [])
.directive('statCard', function() {

  return {

    template: '<div class="stat-card" ng-class="type"><h4 class="text-center stat-card-title">{{title}}</h4><span class="stat-card-content">{{content}}</span><p class="stat-card-metadata">{{metadata}}</p></div>',
    restrict: 'E',
    scope: {
      type: '@',
      title: '@',
      content: '@',
      metadata: '@'
    }
  //  template: '<div class="stat-card"><h5>{{title}}</h5><span class="stat-card-content">{{content}}</span></div>'
  }

}).name;



// WEBPACK FOOTER //
// ./client/components/stat-card/stat-card.directive.js